import ReactMarkdown from "react-markdown";

function getExperience() {
  const start = new Date(2016, 6); // July 2016
  const now = new Date();

  const diffInMonths =
    (now.getFullYear() - start.getFullYear()) * 12 +
    (now.getMonth() - start.getMonth());

  return (diffInMonths / 12).toFixed(1);
}

const About = ({ text }: { text: string }) => {
  const formattedText = text.replace("{exp}", getExperience());

  return (
    <div style={{ lineHeight: "1.7", fontSize: "16px", color: "#999999" }}>
      <ReactMarkdown>{formattedText}</ReactMarkdown>
    </div>
  );
};

export default About;